import { detectCedeProvider } from '@cedelabs/providers';
import { createEIP1193Provider } from '@web3-onboard/common';
function cedeStoreWallet() {
    if (typeof window === 'undefined')
        return () => null;
    return () => ({
        label: 'cede.store',
        injectedNamespace: 'cede',
        checkProviderIdentity: () => window.cede,
        getIcon: async () => (await import('./icon.js')).default,
        getInterface: async () => {
            const provider = await detectCedeProvider();
            if (!provider) {
                window.open('https://cede.store', '_blank');
                throw new Error('Please, install cede.store to use this wallet');
            }
            // handle disconnect
            provider.once('lock', () => {
                provider.emit('accountsChanged', []);
            });
            return Promise.resolve({
                provider: createEIP1193Provider(provider, {
                    eth_requestAccounts: async () => {
                        const accounts = await provider.request({
                            method: 'connect'
                        });
                        if (!accounts.length) {
                            return [];
                        }
                        const activeVault = accounts.find(account => account.isActive);
                        return [(activeVault === null || activeVault === void 0 ? void 0 : activeVault.name) || accounts[0].name];
                    },
                    eth_chainId: () => Promise.resolve('0x1'),
                    wallet_switchEthereumChain: null,
                    wallet_addEthereumChain: null,
                    eth_getBalance: () => Promise.resolve('0x0'),
                    eth_selectAccounts: null
                })
            });
        },
        platforms: ['desktop']
    });
}
export default cedeStoreWallet;
